import Vue, { CreateElement } from 'vue'

import { Prop } from 'vue-property-decorator'
import { Mixin } from 'vue-mixin-decorator'

import { noop } from '@src/util/noop'

import { Icon } from '@src/elements/icon/icon'

import { Alignable } from '@src/mixins/alignable/alignable'
import { Selectable } from '@src/mixins/selectable/selectable'

@Mixin
export class Element extends Vue {

  @Prop({ required: false })
  icon: string

  @Prop({ required: false, type: [Object, String] })
  label

  @Prop({ required: false })
  detail: string

  @Prop({ required: false })
  disabled: boolean

  @Prop({ required: false })
  click: () => void

  protected get elementStyles () {
    let styleClasses = ['element']

    if (this.disabled === true) {
      styleClasses.push('disabled')
    }

    if (this.icon) {
      styleClasses.push('has-icon')
    }

    return styleClasses
  }

  protected renderElement (h: CreateElement, styleClasses: string[], key: any, contents, click?: () => void) {
    return <div id={key} key={key} class={styleClasses.join(' ')} onClick={
      this.disabled ? noop : (click ? click : (this.click ? this.click : noop))
    }>
      {contents}
    </div>
  }

  protected renderIcon (h: CreateElement) {
    if (!this.icon) {
      return null
    }

    if (!this.label) {
      return <div class='icon-only'>
        <Icon name={this.icon} />
      </div>
    } else {
      return <div class='left-icon'>
        <Icon name={this.icon} />
      </div>
    }
  }

  protected renderLabel (h: CreateElement) {
    if (!this.label) {
      return null
    }

    if (!this.detail) {
      return <div class='stretch'>
        <p class='label withoutDetail'>{
          // istanbul ignore next: the label is checked above
          this.label ? this.label : this.label
        }</p>
      </div>
    }

    return <div class='stretch'>
      <p class='label'>{
        // istanbul ignore next: the label is checked above
        this.label ? this.label : this.label
      }</p>
      <p class='detail'>{
        // istanbul ignore next: the detail is checked above
        this.detail ? this.detail : this.detail
      }</p>
    </div>
  }

  protected toggleKeyboardEvents (toggle: boolean) {
    if (toggle) {
      document.addEventListener('keyup', this.onDocumentKeyup)
    } else {
      document.removeEventListener('keyup', this.onDocumentKeyup)
    }
  }

  protected toggleOutsideClickEvent (toggle: boolean) {
    if (toggle) {
      document.addEventListener('click', this.onDocumentClick)
    } else {
      document.removeEventListener('click', this.onDocumentClick)
    }
  }

  protected onDocumentClick (ev: Event) {
    if (!this.$el.contains(ev.target as HTMLElement)) {
      this.onClickOutside()
    }
  }

  protected onDocumentKeyup (ev) {
    if (ev.keyCode === 27) {
      this.onEscape()
    }
  }

  protected onEscape () {
    // implement this in children
  }

  protected onClickOutside () {
    // implement this in children
  }

}

export interface AlignableElement extends Element, Alignable { }
export interface SelectableElement extends Element, Selectable { }
